import { trackMixpanel } from '../base';

const COMPONENT = 'Deliveries Waterfall';
const EVENT_NAME = 'End of feed';

export interface GridEndOfFeedProps {
    pageName: string;
    carouselName: string;
}

interface GridEndOfFeedMixpanelProps {
    'Page Name': string;
    'Carousel Name': string;
}

export const trackGridEndOfFeed = (props: GridEndOfFeedProps) => {
    trackMixpanel(COMPONENT, EVENT_NAME, {
        'Page Name': props.pageName,
        'Carousel Name': props.carouselName,
    } satisfies GridEndOfFeedMixpanelProps);
};
